import React, { useState } from 'react';
import ReportFilterBar from '../components/ReportFilterBar';
import ReportTable from '../components/ReportTable';
import ReportDownloadButtons from '../components/ReportDownloadButtons';
import { API_BASE_URL } from '../services/api';

const RepoReportPage = () => {
  const [filters, setFilters] = useState({});
  const [results, setResults] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 20, total: 0 });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  const handleGenerateReport = async (filtersArg) => {
    const usedFilters = filtersArg || filters;
    if (usedFilters.view === 'transactions' && (!usedFilters.dateFrom || !usedFilters.dateTo)) {
      setError('Please select Date From and Date To before generating the transactions report.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({
        ...usedFilters,
        page: pagination.page,
        pageSize: pagination.pageSize
      });
      const res = await fetch(`${API_BASE_URL}/reports/repo?${params.toString()}`);
      if (!res.ok) throw new Error('Failed to fetch report');
      const json = await res.json();
      setResults(json.data || []);
      setPagination((p) => ({ ...p, total: json.total || 0 }));
    } catch (e) {
      setError(e.message || 'Error fetching report');
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = async (newPagination) => {
    setPagination(newPagination);
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({
        ...filters,
        page: newPagination.page,
        pageSize: newPagination.pageSize
      });
      const res = await fetch(`${API_BASE_URL}/reports/repo?${params.toString()}`);
      if (!res.ok) throw new Error('Failed to fetch report');
      const json = await res.json();
      setResults(json.data || []);
      setPagination((p) => ({ ...newPagination, total: json.total || 0 }));
    } catch (e) {
      setError(e.message || 'Error fetching report');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (format) => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({
        ...filters,
        format
      });
      const res = await fetch(`${API_BASE_URL}/reports/repo?${params.toString()}`);
      if (!res.ok) throw new Error('Failed to download report');
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${filters.view === 'transactions' ? 'repo_transactions_report' : 'repo_report'}.${format === 'excel' ? 'xlsx' : format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      setError(e.message || 'Error downloading report');
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <div className="ui-page">
        <div className="p-4 bg-red-50 text-red-700 rounded-lg border border-red-200">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="ui-page">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        {filters.view === 'transactions' ? 'Repo / Reverse Repo Transactions Report' : 'Repo / Reverse Repo Report'}
      </h2>
      <ReportFilterBar
        filters={filters}
        onChange={handleFilterChange}
        onGenerate={handleGenerateReport}
        showReportView
      />
      <ReportDownloadButtons onDownload={handleDownload} disabled={loading || results.length === 0} />
      <ReportTable
        data={results}
        pagination={pagination}
        loading={loading}
        error={error}
        onPageChange={handlePageChange}
        reportType="repo"
      />
    </div>
  );
};

export default RepoReportPage;

